export enum DialogBackgrounds {
  ADD_LOCATION = 'add-location-bg-2.jpg',
}

export enum CookieType {
  FUNCTIONAL = 'functional',
  PERFORMANCE = 'performance',
}
